module.exports = __webpack_public_path__ + "img/pa.00f1e6c9.svg";